import { useSelector } from "react-redux";
import { adjustHexColor as hexToHLS } from "../../../utils/functions/hexToHLS";

const CustomPromptIcon = ({ className }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);

  return (
    <svg
      id="uuid-f1752d2f-68d2-43c6-86df-2122bdd7c580"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 69.8 71.4"
      className={className}
    >
      <path
        d="M69.8,67.5c0,1.6-9,3-21.8,3.6-4,.2-8.5.3-13.1.3-19.3,0-34.9-1.8-34.9-3.9s5.1-2.3,12.9-3c6-.5,13.6-.9,21.9-.9s9,0,13.1.3c3.2,0,6.2.3,8.8.6,7.9.7,12.9,1.8,12.9,3h.2Z"
        fill="#d1d1d1"
      />
      <path
        d="M69.8,67.5c0,1.6-9,3-21.8,3.6-12.8-.6-21.8-2-21.8-3.6s5-2.3,12.9-3c2.7-.2,5.6-.4,8.9-.6,3.2,0,6.2.3,8.8.6,7.9.7,12.9,1.8,12.9,3h.1Z"
        fill="#c1c0bf"
      />
      <g>
        <rect
          x="2.1"
          y="1"
          width="65.6"
          height="56.9"
          rx="8.2"
          ry="8.2"
          fill="#fff"
        />
        <path d="M59.5,1c4.5,0,8.2,3.7,8.2,8.2v40.5c0,4.5-3.7,8.2-8.2,8.2H10.3c-4.5,0-8.2-3.7-8.2-8.2V9.2C2.1,4.7,5.8,1,10.3,1h49.2M59.5,0H10.3C5.2,0,1.1,4.1,1.1,9.2v40.5c0,5.1,4.1,9.2,9.2,9.2h49.2c5.1,0,9.2-4.1,9.2-9.2V9.2c0-5.1-4.1-9.2-9.2-9.2h0Z" />
      </g>
      <path
        d="M67.7,9.2v40.5c0,4.5-3.7,8.2-8.2,8.2h-3.5c4.5,0,8.2-3.7,8.2-8.2V9.2c0-4.5-3.7-8.2-8.2-8.2h3.5c4.5,0,8.2,3.7,8.2,8.2Z"
        fill="#e6e6e6"
      />
      <g>
        <path
          d="M59.5,1H10.3C5.7,1,2.1,4.7,2.1,9.2v6.8h65.6v-6.8c0-4.5-3.7-8.2-8.2-8.2Z"
          fill={colorPrimary}
        />
        <path d="M59.5,1c4.5,0,8.2,3.7,8.2,8.2v6.8H2.1v-6.8C2.1,4.7,5.7,1,10.3,1h49.2M59.5,0H10.3C5.2,0,1.1,4.1,1.1,9.2v7.8h67.6v-7.8c0-5.1-4.1-9.2-9.2-9.2h0Z" />
      </g>
      <path
        d="M59.5,1h-3.5c4.5,0,8.2,3.7,8.2,8.2v6.8h3.5v-6.8c0-4.5-3.7-8.2-8.2-8.2Z"
        fill={hexToHLS(colorPrimary)}
      />
      <g id="uuid-d249ff4b-f15c-46b6-9d4b-664006d2d297">
        <g id="uuid-84d7e29b-9f1b-4c89-80de-f4f5aaba7343">
          <g>
            <path
              id="uuid-1814b742-745f-4097-b4cb-a18fab6cf456"
              d="M11.6,28.7c-.5-.5-.8-1.2-.8-2s.1-1.1.5-1.5l.2-.2h.1c.2-.3.4-.5.7-.7.9-.5,2.1-.4,2.9.2l12.4,9.2c1.2.9,1.5,2.6.6,3.8-.2.2-.4.4-.6.6l-12.4,9.2c-.5.3-1,.5-1.6.5s-.9,0-1.3-.3c-.3,0-.5-.3-.7-.5-.1,0-.2-.2-.3-.3-.3-.4-.5-1-.5-1.5,0-.8.3-1.5.8-2l.4-.4,5.8-5.6c.7-.7.7-1.8,0-2.5h0l-6.2-6h0Z"
              fill={colorPrimary}
            />
            <path d="M13.5,48.4c-.5,0-1.1,0-1.6-.4-.3-.2-.6-.4-.8-.7-.1,0-.2-.2-.3-.4-.4-.5-.6-1.2-.6-1.8,0-.9.4-1.7,1-2.3l.4-.4,5.8-5.6c.5-.5.5-1.3,0-1.8l-6.2-6c-.6-.6-1-1.5-1-2.3s.2-1.3.6-1.8l.2-.2s.1-.1.1-.2c.2-.2.5-.5.8-.6,1.1-.6,2.5-.5,3.5.2l12.4,9.2c1.4,1,1.7,3.1.7,4.5-.2.2-.4.5-.7.7l-12.4,9.2c-.6.4-1.2.6-1.9.6h0v.1ZM12,28.4l6.2,6c.9,1,.9,2.4,0,3.2l-6.2,6c-.4.4-.7,1-.7,1.6s.1.9.4,1.2c0,0,.1.2.2.2.2.2.4.3.6.5.8.4,1.7.4,2.4-.2l12.4-9.2c.2-.2.4-.3.5-.5.7-1,.5-2.4-.5-3.1l-12.4-9.2c-.7-.5-1.6-.6-2.4-.2-.2.1-.4.3-.6.5l-.2.3c-.2.3-.4.8-.4,1.2s.2,1.2.7,1.6h0s0,.1,0,.1Z" />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            d="M29.9,42.6h12.4c.4,0,.7.3.7.6v3.6c0,.3-.3.6-.7.6h-12.4c-.4,0-.7-.3-.7-.6v-3.6c0-.3.3-.6.7-.6Z"
            fill={hexToHLS(colorSecondary)}
          />
          <path d="M42.3,42.6c.4,0,.7.3.7.6v3.6c0,.3-.3.6-.7.6h-12.4c-.4,0-.7-.3-.7-.6v-3.6c0-.3.3-.6.7-.6h12.4M42.3,41.6h-12.4c-1,0-1.7.7-1.7,1.6v3.6c0,.9.8,1.6,1.7,1.6h12.4c1,0,1.7-.7,1.7-1.6v-3.6c0-.9-.8-1.6-1.7-1.6h0Z" />
        </g>
        <path
          d="M29.9,44.4h12.4c.4,0,.7.3.7.6v1.8c0,.3-.3.6-.7.6h-12.4c-.4,0-.7-.3-.7-.6v-1.8c0-.3.3-.6.7-.6Z"
          fill={colorSecondary}
        />
      </g>
    </svg>
  );
};

export default CustomPromptIcon;
